var global = require('./_global')
 , core = require('./_core')
 , LIBRARY = require('./_library')
 , wksExt = require('./_wks-ext')
 , defineProperty = require('./_object-dp').f;
module.exports = function(name){
 var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
 if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-define.js
// module id = 26
// module chunks = 0